import React from 'react'
import styled from 'styled-components'
import { graphql, useStaticQuery } from 'gatsby'

// Elements
import PostGrid from 'components/elements/Posts/PostGrid'
import BlogBink, {
  useBlogBink,
  BlogBinkFilter,
  BlogBinkPosts,
} from '@ubo/blog-bink'

interface KeynotesProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location: any
}

const Keynotes: React.FC<KeynotesProps> = ({ fields }) => {
  const {
    allWpKeynote,
    // eslint-disable-next-line
  } = useStaticQuery<GatsbyTypes.keynoteQueryQuery>(graphql`
    query keynoteQuery {
      allWpKeynote(sort: { order: DESC, fields: date }) {
        edges {
          node {
            ...generalKeynoteFragment
          }
        }
      }
    }
  `)

  const posts: unknown = allWpKeynote.edges

  return (
    <section>
      <BlogBink
        posts={posts as BlogBinkPosts}
        id="keynotes"
        limit={Number(fields.limit)}
      >
        <div className="py-5">
          <div className='py-5'>
            <PostGrid fields={fields} />
          </div>
        </div>
      </BlogBink>
    </section>
  )
}


export default Keynotes
